import { AbstractCollection } from '../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable, Untrackable } from '../../abstract/Document';
import { type Supplier, Suppliers } from '../Suppliers';
import type { IOffer } from './Offers.types';

@Identifiable
@Timestampable
@Untrackable
export class Offer extends AbstractDocument<IOffer> {
  readonly collections = {};

  readonly translatable = (data: IOffer): NonNullable<IOffer['_translations']>[string] => ({
    details: data.details,
    title: data.title,
  });
}

export class Offers extends AbstractCollection<Offer, IOffer> {
  static path = 'offers';

  constructor(document: Supplier) {
    super(document.collection(Offers.path), Offer);
  }

  get supplier() {
    return Suppliers._.getById(this.reference.parent!.id);
  }
}
